import styled from 'styled-components';

import { StyledFlex } from '@dreryk/react-components';

export const StyledPatientPrescriptionsHistory = styled(StyledFlex)`
   height: 100%;
`;
